module.exports = __webpack_public_path__ + "static/img/project_05.9e4c0329.png";